<div cdkDragHandle class="card-sort"></div>
<div class="name">
  <label class="label1">{{ name }}</label>
</div>
<div class="card-info">
  <div class="col justify-content-center">
    <label class="label-value">{{ price | currency }}</label>
  </div>
</div>
<div class="card-info">
  <div class="col justify-content-center">
    <label class="label-value">{{ max }}</label>
  </div>
</div>

<div class="card-info">
  <div class="col justify-content-center">
    <label class="label-value">{{ sold }}</label>
  </div>
</div>

<div class="card-info">
  <a style="color: #429DFF" (click)="edit(0)"
    ><img
      src="../../../assets/icons/edit.svg"
      style="width:15px;height:15px;margin-right: 5px;"
    /><u style="font-size: 15px;">Details</u></a
  >
</div>
<div class="card-details">
  <a style="color: #429DFF" (click)="edit(1)"
    ><img
      src="../../../assets/icons/edit.svg"
      style="width:15px;height:15px;"
    /><u style="font-size: 15px;">Schedule</u></a
  >
</div>
<div class="card-visible" *ngIf="pass.event.isVisible(pass.product)"></div>
